import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../../core/core.module';

import { State } from '../../../../vista-usuario/vista-usuario.state';
import { entityStepperReset } from '../../../../actividades/entity-stepper/stepper.actions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rpe-vista-registro-empresa-container',
  templateUrl: './vista-registro-empresa-container.component.html',
  styleUrls: ['./vista-registro-empresa-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VistaRegistroEmpresaContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  subscription: Subscription

  constructor(private store: Store<State>) { }

  ngOnInit(): void {
    this.store.dispatch(entityStepperReset());
  }
}
